var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 200,
    viewBox: "0 0 352 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_83306)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 200,
    rx: 8,
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 70C89.8436 70 20 139.844 20 226H332C332 139.844 262.156 70 176 70Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5,
    y1: 104,
    x2: 176.5,
    y2: 140,
    stroke: "white",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5,
    y1: 44,
    x2: 176.5,
    y2: 80,
    stroke: "white",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5,
    y1: 164,
    x2: 176.5,
    y2: 200,
    stroke: "white",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 40C156 28.9543 164.954 20 176 20C187.046 20 196 28.9543 196 40C196 51.0457 187.046 60 176 60C164.954 60 156 51.0457 156 40Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.833 38.3334H185.167M168.5 33.3334H183.5C184.421 33.3334 185.167 34.0796 185.167 35V45C185.167 45.9205 184.421 46.6667 183.5 46.6667H168.5C167.58 46.6667 166.833 45.9205 166.833 45V35C166.833 34.0796 167.58 33.3334 168.5 33.3334Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 100C156 88.9543 164.954 80 176 80C187.046 80 196 88.9543 196 100C196 111.046 187.046 120 176 120C164.954 120 156 111.046 156 100Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.333 100.833C174.691 101.312 175.148 101.708 175.672 101.994C176.197 102.281 176.776 102.451 177.372 102.494C177.968 102.536 178.566 102.45 179.126 102.241C179.686 102.033 180.194 101.706 180.617 101.283L183.117 98.7833C183.876 97.9975 184.296 96.945 184.286 95.8525C184.277 94.76 183.839 93.715 183.066 92.9424C182.294 92.1699 181.248 91.7317 180.156 91.7222C179.064 91.7127 178.011 92.1327 177.225 92.8917L175.792 94.3167M177.667 99.1667C177.309 98.6882 176.852 98.2924 176.328 98.0059C175.804 97.7194 175.224 97.5491 174.628 97.5064C174.032 97.4637 173.434 97.5497 172.874 97.7585C172.314 97.9673 171.806 98.2941 171.383 98.7167L168.883 101.217C168.125 102.003 167.705 103.055 167.714 104.148C167.724 105.24 168.162 106.285 168.934 107.058C169.707 107.83 170.752 108.268 171.844 108.278C172.937 108.287 173.989 107.867 174.775 107.108L176.2 105.683",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 160C156 148.954 164.954 140 176 140C187.046 140 196 148.954 196 160C196 171.046 187.046 180 176 180C164.954 180 156 171.046 156 160Z",
    fill: "#175CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.833 159.167V155.833C171.833 154.728 172.272 153.668 173.054 152.887C173.835 152.106 174.895 151.667 176 151.667C177.105 151.667 178.165 152.106 178.946 152.887C179.728 153.668 180.167 154.728 180.167 155.833V159.167M170.167 159.167H181.833C182.754 159.167 183.5 159.913 183.5 160.833V166.667C183.5 167.587 182.754 168.333 181.833 168.333H170.167C169.246 168.333 168.5 167.587 168.5 166.667V160.833C168.5 159.913 169.246 159.167 170.167 159.167Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_83306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.beb20bc3e31ffc07df179a6b5ae467b4.svg";
export { ForwardRef as ReactComponent };